import { render, staticRenderFns } from "./CalendarioPreventivo.vue?vue&type=template&id=b2854372&"
import script from "./CalendarioPreventivo.vue?vue&type=script&lang=js&"
export * from "./CalendarioPreventivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports